//@flow
import i18n from 'i18next'
import en from '../locales/en'

i18n.init({
  debug: process.env.NODE_ENV === 'development',
  fallbackLng: 'en',
  defaultNS: 'app',
  resources: { en }
})

export const t: (key: string, ...rest: any) => string = i18n.t.bind(i18n)

export const exists = i18n.exists.bind(i18n)

export const changeLanguage: string => void = (lng: string) => {
  i18n.changeLanguage(lng)
}

export const convertDomainToKey = (domain: string): string => {
  switch (domain) {
    case 'charities':
      return 'charity'
    case 'auctions':
      return 'auction'
    case 'items':
      return 'item'
    default:
      return 'results'
  }
}

export default i18n



// WEBPACK FOOTER //
// ./src/core/i18n.js